import { BaseInquiryStatus, BaseOfferStatus } from '../_enums/base-inquiry.enum';

export const BASE_CUSTOMER_INQUIRY_STATUS_OPTIONS = [
  { name: 'states.published', id: BaseInquiryStatus.published, class: 'inquiry-released-customer-filter-state' },
  {
    name: 'states.unpublished',
    id: BaseInquiryStatus.unpublished,
    class: 'inquiry-unpublished-customer-filter-state',
  },
  { name: 'states.closed', id: BaseInquiryStatus.closed, class: 'inquiry-closed-customer-filter-state' },
];

export const BASE_CUSTOMER_OFFER_STATUS_OPTIONS = [
  { name: 'shiftStatus.legend.offered', id: BaseOfferStatus.open, class: 'offer-offered-filter-state' },
  { name: 'action.preselected', id: BaseOfferStatus.preselected, class: 'offer-preselected-filter-state' },
  {
    name: 'action.accepted',
    id: BaseOfferStatus.confirmed,
    class: 'offer-accepted-filter-state',
  },
  { name: 'action.declined', id: BaseOfferStatus.declined, class: 'offer-declined-filter-state' },
];

export const BASE_PSP_INQUIRY_STATUS_OPTIONS = [
  { name: 'inquiry.open', id: BaseInquiryStatus.published, class: 'inquiry-open-filter-state' },
  { name: 'states.closed', id: BaseInquiryStatus.closed, class: 'inquiry-closed-filter-state' },
];
